import React, {useEffect} from 'react';
import {Checkbox, Text} from '@gravity-ui/uikit';
import {ActionModal, FormInput, useErrorHandler, ErrorModal} from '../../../../shared';
import {useEditConsentDocumentForm} from '../../model';
import styles from './EditConsentDocumentModal.module.scss';

interface EditConsentDocumentModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  documentId: string | null;
}

export const EditConsentDocumentModal = ({open, setOpen, documentId}: EditConsentDocumentModalProps) => {
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    setFieldValue,
    resetForm,
    submitForm,
    isLoading,
    submitError,
  } = useEditConsentDocumentForm({setOpen, documentId});

  const {isErrorModalOpen, errorInfo, handleError, handleClose} = useErrorHandler({
    resourceName: 'Документ согласия',
    title: 'Ошибка при редактировании документа согласия',
  });

  useEffect(() => {
    if (submitError) {
      handleError(submitError);
    }
  }, [submitError, handleError]);

  return (
    <>
      <ActionModal
        open={open}
        onClose={() => setOpen(false)}
        setOpen={() => setOpen(false)}
        resetForm={resetForm}
        submitForm={submitForm}
        isLoading={isLoading}
        size={'m'}
        buttonsSize={'l'}
        caption={'Редактирование документа'}
        textButtonApply={'Сохранить'}
        textButtonCancel={'Отменить'}>
        <FormInput
          label="Название документа"
          placeholder="Название документа"
          name="title"
          value={values.title}
          onChange={handleChange}
          onBlur={handleBlur}
          isRequired
          error={touched.title && errors.title}
        />

        <FormInput
          label="Текст для показа"
          name="displayText"
          value={values.displayText}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="Текст для показа"
          isRequired
          error={touched.displayText && errors.displayText}
        />

        <FormInput
          label="Порядок показа"
          placeholder="Порядок показа"
          name="order"
          type="number"
          value={values.order.toString()}
          onChange={handleChange}
          onBlur={handleBlur}
          error={touched.order && errors.order}
        />

        <div className={styles.checkboxContainer}>
          <Text variant="subheader-1" className={styles.checkboxTitle}>
            Отдельно
          </Text>
          <Checkbox
            checked={values.isDistinguished}
            onUpdate={(checked) => setFieldValue('isDistinguished', checked)}
          />
        </div>

        <div className={styles.checkboxContainer}>
          <Text variant="subheader-1" className={styles.checkboxTitle}>
            Обязательный
          </Text>
          <Checkbox
            checked={values.isMandatory}
            onUpdate={(checked) => setFieldValue('isMandatory', checked)}
          />
        </div>
      </ActionModal>

      <ErrorModal open={isErrorModalOpen} onClose={handleClose} title={errorInfo.title} message={errorInfo.message} />
    </>
  );
};
